<template>
	<div class="global-pagination">
		<div class="global-pagination__container">
			<div class="global-pagination__icon" :class="{ 'global-pagination__icon--disabled': model == 1 }" @click="handlePreviousPage">
				<GlobalIcon name="arrow-previous" :height="20" />
			</div>
			<InputSecondary v-model="model" type="tel" class="global-pagination__input" @update:model="handleUpdateModel" />
			<span class="global-pagination__text">{{ t('common.of') }}</span>
			<span class="global-pagination__text">{{ maxPage }}</span>
			<div class="global-pagination__icon" :class="{ 'global-pagination__icon--disabled': model >= maxPage }" @click="handleNextPage">
				<GlobalIcon name="arrow-next" :height="20" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
const props = defineProps<{
	maxPage: number
	asParam?: boolean
}>()

const model = defineModel<number>({
	required: true,
})

const { t } = useI18n()

const emit = defineEmits<{
	(e: 'update:model', value: number): void
	(e: 'handleNextPage'): void
	(e: 'handlePreviousPage'): void
}>()

const router = useRouter()

const page = router.currentRoute.value.query.page
if (page) emit('update:model', +page)

const handleNextPage = () => {
	if (model.value < props.maxPage) {
		// emit('update:model', model.value + 1)
		model.value = model.value + 1
		if (props.asParam) {
			router.push(localePath({ params: { page: model.value } }))
		} else {
			router.push(localePath({ query: { page: model.value } }))
		}
		emit('handleNextPage')
	}
}

const handlePreviousPage = () => {
	if (model.value > 1 && model.value <= props.maxPage) {
		// emit('update:model', model.value - 1)
		model.value = model.value - 1
		if (props.asParam) {
			router.push(localePath({ params: { page: model.value - 1 > 1 ? model.value - 1 : null } }))
		} else {
			router.push(localePath({ query: { page: model.value - 1 } }))
		}
		emit('handlePreviousPage')
	}
}

const handleUpdateModel = (value: number) => {
	if (value > 0 && value <= props.maxPage) {
		if (props.asParam) {
			router.push(localePath({ params: { page: value } }))
		} else {
			router.push(localePath({ query: { page: value } }))
		}
	}
}

watch(
	() => model.value,
	(newValue) => {
		// if (newValue < 1) emit('update:model', 1)
		if (newValue < 1) model.value = 1
		// if (newValue > props.maxPage) emit('update:model', props.maxPage)
		if (newValue > props.maxPage) model.value = props.maxPage
		if (model.value) emit('update:model', newValue)

		handleUpdateModel(newValue)
	},
)
</script>

<style lang="scss">
@import './Pagination.scss';
</style>
